import {List, Record} from 'immutable';
import User, {UserId} from 'records/User';
import {Int, RecordProps} from '@store/@types/util';
import {FilterWordProfileId} from 'records/admin/topics/NewFilterWordProfile';
import {DepartmentId} from 'records/Department';
import {TeamId} from 'records/TeamId';

export default class Team extends Record({
  id: undefined,
  name: undefined,
  usersCount: undefined,
  departmentId: undefined,
  manager: undefined,
  managerId: undefined,
  users: undefined,
  filterWordProfileId: undefined,
}) {
  readonly id: TeamId;
  readonly name: string;
  readonly usersCount: Int;
  readonly departmentId: DepartmentId;
  readonly manager: User;
  readonly managerId: UserId;
  readonly users: List<User>;
  readonly filterWordProfileId: FilterWordProfileId;

  constructor(props: RecordProps<Team> & {profileFilterWordsId?: FilterWordProfileId} = {}) {
    super({
      ...props,
      // Support both the view and direct from the database
      filterWordProfileId: props.filterWordProfileId ?? props.profileFilterWordsId,
      users: props.users ? List(props.users!.map(u => new User(u))) : undefined,
    });
  }
}
